document.addEventListener("DOMContentLoaded", function() {
    // Smooth scroll to anchor links
    $('a').click(function(e) {
        if(this.href.substring(this.href.indexOf('#') + 1) != 'content-section') {
            scrollToAnchor(this.href, e, 40);
        }
    });

    window.scrollToAnchor = scrollToAnchor;
});

export const scrollToAnchor = function(href, event, offset) {
    if (href.length <= 1) {
        return;
    }

    var hashIndex = href.indexOf('#');

    if (hashIndex === -1) {
        return;
    }

    var id = href.substring(hashIndex + 1);

    if (!id) {
        return;
    }

    var $el = $('#' + id);

    if ($el.length === 0){
        return;
    }

    $('html, body').animate({
        scrollTop: $el.offset().top - (offset || 0)
    }, 300);

    if (event) {
        event.preventDefault();
    }
}